// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form.standard-form {
  padding: 1em;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 1em;

  width: fit-content;
  max-width: 100%;
  margin: 0 auto;
}

div.standard-form-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
  flex-wrap: wrap;
  gap: 0.4em;
  width: 100%;
}

div.standard-form-row.start {
  justify-content: start;
}

div.standard-form-row.space-between {
  justify-content: space-between;
}

.standard-input {
  border: var(--border-pri);
  padding: 0.2em 0.4em;
  display: flex;
  justify-content: center;
  align-items: center;
}

.standard-input:hover, .standard-input:focus {
  color: var(--clr-accent-dark);
  box-shadow: var(--box-shadow-normal);
}

select.standard-input {
  width: fit-content;
}

.standard-button {
  border: var(--border-pri);
  padding: 0.2em 0.4em;
  /* text-transform: capitalize; */
  cursor:default;
  user-select: none;
}

.standard-button:hover, .standard-button:focus {
  box-shadow: var(--box-shadow-normal);
  color: var(--clr-accent-dark);
}

.standard-button:active:hover {
  scale: 0.95;
  box-shadow: var(--box-shadow-small);
}

.standard-button:disabled {
  color: var(--clr-accent-light);
  border-color: var(--clr-accent-light);
  pointer-events: none;
}

.icon-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.2em;
}

button.hidden-submit-button {
  display: none;
  position: absolute;
}

.link-button {
  cursor: pointer;
  text-decoration: underline;
  color: var(--clr-accent-dark);
}

.link-button:hover {
  color: var(--clr-accent-light);
}

div.standard-form-labeled-checkbox-wrapper>input {
  width: 1em;
  height: 1em;
  border: var(--border-pri);
}

div.standard-form-labeled-checkbox-wrapper>input:checked {
  background-color: var(--clr-accent-dark);
}

label {
  cursor:default;
  user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/styles/forms.css"],"names":[],"mappings":"AAAA;EACE,YAAY;;EAEZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;;EAEnB,QAAQ;;EAER,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,UAAU;EACV,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB","sourcesContent":["form.standard-form {\n  padding: 1em;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  gap: 1em;\n\n  width: fit-content;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\ndiv.standard-form-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: stretch;\n  flex-wrap: wrap;\n  gap: 0.4em;\n  width: 100%;\n}\n\ndiv.standard-form-row.start {\n  justify-content: start;\n}\n\ndiv.standard-form-row.space-between {\n  justify-content: space-between;\n}\n\n.standard-input {\n  border: var(--border-pri);\n  padding: 0.2em 0.4em;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.standard-input:hover, .standard-input:focus {\n  color: var(--clr-accent-dark);\n  box-shadow: var(--box-shadow-normal);\n}\n\nselect.standard-input {\n  width: fit-content;\n}\n\n.standard-button {\n  border: var(--border-pri);\n  padding: 0.2em 0.4em;\n  /* text-transform: capitalize; */\n  cursor:default;\n  user-select: none;\n}\n\n.standard-button:hover, .standard-button:focus {\n  box-shadow: var(--box-shadow-normal);\n  color: var(--clr-accent-dark);\n}\n\n.standard-button:active:hover {\n  scale: 0.95;\n  box-shadow: var(--box-shadow-small);\n}\n\n.standard-button:disabled {\n  color: var(--clr-accent-light);\n  border-color: var(--clr-accent-light);\n  pointer-events: none;\n}\n\n.icon-button {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 0.2em;\n}\n\nbutton.hidden-submit-button {\n  display: none;\n  position: absolute;\n}\n\n.link-button {\n  cursor: pointer;\n  text-decoration: underline;\n  color: var(--clr-accent-dark);\n}\n\n.link-button:hover {\n  color: var(--clr-accent-light);\n}\n\ndiv.standard-form-labeled-checkbox-wrapper>input {\n  width: 1em;\n  height: 1em;\n  border: var(--border-pri);\n}\n\ndiv.standard-form-labeled-checkbox-wrapper>input:checked {\n  background-color: var(--clr-accent-dark);\n}\n\nlabel {\n  cursor:default;\n  user-select: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
